import dynamic from 'next/dynamic';

export const homeComponents = {
  hero_cta_with_logos: dynamic(() => import('./HeroCtaWithLogos')),
  headline_with_stat_cards: dynamic(() => import('./HeadlineWithStatCards')),
  headline_centered_illustration: dynamic(
    () => import('./HeadlineCenteredAnimation'),
  ),
  headline_description_cta_steps: dynamic(
    () => import('./HeadlineDescriptionCtaSteps'),
  ),
  feature_highlight_split: dynamic(() => import('./FeatureHighlightSplit')),
  headline_logos_row: dynamic(() => import('./HeadlineLogosRow')),
  testimonial_carousel: dynamic(() => import('./TestimonialCarousel')),
  hero_with_bullet_points: dynamic(() => import('./HeroWithBulletPoints')),
};
